import { Injectable, Pipe } from '@angular/core';

/*
  Generated class for the WithoutProperty pipe.

  See https://angular.io/docs/ts/latest/guide/pipes.html for more info on
  Angular 2 Pipes.
*/
@Pipe({
  name: 'withoutProperty'
})
@Injectable()
export class WithoutPropertyPipe {
  /*
    Takes a value and makes it lowercase.
   */
  transform(values, args) {

    let property = args.split(',')[0];

    values = values.filter(value => {
      return !value[property]
    });

    return values;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/without-property.ts